module.exports = __webpack_public_path__ + "/static/assets/4b79b64e593be0d5e8701ff5a2ea6f66.gif";